import { ResizablePanelsRoot } from './ResizablePanelsRoot';
import { ResizablePanelsPanel } from './ResizablePanelsPanel';
import { ResizablePanelsHandle } from './ResizablePanelsHandle';

/**
 * Resizable namespace
 *
 * @example
 * ```tsx
 * <Resizable.Root defaultWidths={[200, 300]}>
 *   <Resizable.Panel index={0}>
 *     <div>Panel 1</div>
 *   </Resizable.Panel>
 *   <Resizable.Handle index={0} />
 *   <Resizable.Panel index={1}>
 *     <div>Panel 2</div>
 *   </Resizable.Panel>
 *   <Resizable.Handle index={1} />
 *   <Resizable.Panel index={2}>
 *     <div>Panel 3 (auto-size)</div>
 *   </Resizable.Panel>
 * </Resizable.Root>
 * ```
 */
export const Resizable = {
  Root: ResizablePanelsRoot,
  Panel: ResizablePanelsPanel,
  Handle: ResizablePanelsHandle,
} as const;
